import { createContext, useEffect, useReducer } from 'react'

export const CardContext = createContext()

const initialState = []

export const PaymentCardReducer = (state, action) => {
	switch (action.type) {
		case 'ADD_CARD':
			return [...state, action.payload]
		default:
			return state
	}
}

export function CardContextProvider({ children }) {
	const [state, dispatch] = useReducer(PaymentCardReducer, initialState, () => {
		try {
			const localCards = localStorage.getItem('cards')
			return localCards ? JSON.parse(localCards) : initialState
		} catch (error) {
			//Ideally this is where I would dispatch an 'ERROR' to the Reducer
			console.log(error)
		}
	})

	useEffect(() => {
		localStorage.setItem('cards', JSON.stringify(state))
	}, [state])

	return (
		<CardContext.Provider value={{ value: state, dispatch: dispatch }}>
			{children}
		</CardContext.Provider>
	)
}
